import store from '@/store'
import pick from 'lodash/pick'
import { ROUTE_QUERY_KEYS_PRESERVED_ON_REDIRECT } from '@/utils/openNewDeviceFromStock'

/**
 * redirect to correct device type or to no devices
 */
export const deviceTypeGuard = async (to, from, next) => {
  const availableDeviceTypes = store.getters['user/availableDeviceTypes']
  if (to.name === 'NoDevicesPage' && !availableDeviceTypes?.length) {
    next()
  }

  // Preserve invitation / admin-bridge / stock-promotion query params across redirects.
  const newQuery = pick(to.query, ROUTE_QUERY_KEYS_PRESERVED_ON_REDIRECT)

  if (!availableDeviceTypes?.length) {
    next({ name: 'NoDevicesPage', query: newQuery })
  } else {
    if (to.name === 'NoDevicesPage') {
      next({ name: 'DeviceListPage', params: { type: availableDeviceTypes[0] }, query: newQuery })
    }
    const targetDeviceType = to.params.type
    if (availableDeviceTypes.includes(targetDeviceType)) {
      next()
    } else {
      next({ name: 'DeviceListPage', params: { type: availableDeviceTypes[0] }, query: newQuery })
    }
  }
}
